import clsx from "clsx";
import styles from "./IconLink.module.css";

type IconLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  children: React.ReactNode;
};

export const IconLink = ({ children, className, ...props }: IconLinkProps) => {
  return (
    <a className={clsx(styles.link, className)} {...props}>
      {children}
    </a>
  );
};
